import React from 'react'
import { useTranslation } from 'react-i18next'

function Accordion() {
  const { t } = useTranslation('home')
  const steps = [
    {
      title: t('process_step1_title'),
      content: t('process_step1_content'),
    },
    {
      title: t('process_step2_title'),
      content: t('process_step2_content'),
    },
    {
      title: t('process_step3_title'),
      content: t('process_step3_content'),
    },
    {
      title: t('process_step4_title'),
      content: t('process_step4_content'),
    },
  ]
  const [openIndex, setOpenIndex] = React.useState(0)

  return (
    <div className="space-y-4">
      {steps.map((step, idx) => (
        <div key={idx}>
          <button
            className={`w-full flex justify-between items-center p-4 rounded-lg font-bold text-left transition bg-[#eaf3f6] text-primary focus:outline-none ${
              openIndex === idx ? 'shadow' : ''
            }`}
            onClick={() => setOpenIndex(openIndex === idx ? -1 : idx)}
            aria-expanded={openIndex === idx}
          >
            <span>{step.title}</span>
            <span
              className={`transform transition-transform ${
                openIndex === idx ? 'rotate-90' : ''
              }`}
            >
              ▶
            </span>
          </button>
          {openIndex === idx && (
            <div className="bg-white border border-[#eaf3f6] rounded-b-lg p-4 text-gray-700 animate-fade-in">
              {step.content}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

const StepsSection = () => {
  const { t } = useTranslation('home')
  return (
    <section className="bg-white py-16">
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-between gap-8">
        {/* 步骤列表 - Accordion */}
        <div className="md:w-1/2 w-full px-4 mb-8 md:mb-0">
          <h2 className="text-2xl font-bold mb-6 text-primary">
            {t('shipping_process')}
          </h2>
          <Accordion />
        </div>
        {/* 图片 */}
        <div className="md:w-1/2 w-full flex justify-center">
          <img
            src="https://fradaexpress.s3.eu-west-1.amazonaws.com/homepage/process-section.png"
            alt={t('shipping_process')}
            className="rounded-xl shadow-lg object-cover w-full max-w-md"
            width={300}
            height={300}
          />
        </div>
      </div>
    </section>
  )
}

export default StepsSection
